<app-loading-shadow aria-hidden="true" class="loading-offers" *ngIf="isLoading; else showBlock"></app-loading-shadow>
<ng-template #showBlock>
	<article class="ancillary-block" tabindex=0 [attr.aria-label]="INDRA_ariaLabel()">
		<div class="ancillary-block__left" aria-hidden=true>
			<div class="ancillary-block__image" [style.background-image]="INDRA_printImage()"></div>
		</div>
		<div class="ancillary-block__right" aria-hidden=true>
			<div class="ancillary-block__text">
				<div class="ancillary-block__text-top">
					<h5 class="ancillary-block__title">
						{{ INDRA_printTitle() }}
					</h5>
					<div class="ancillary-block__description" *ngIf="showDescription">{{INDRA_printDescription()}}</div>
					<div class="ancillary-block__rating" *ngIf="INDRA_hasStars()">
						<app-svg class="ancillary-block__rating-star" 
							[alt]="'Rating star'" 
							svg="sprite.svg#misc--rating-star--full" 
							*ngFor="let star-full of INDRA_printStar()" aria-hidden=”true”>
						</app-svg>
					</div>
					<div class="ancillary-block__text-bottom">
						<div class="ancillary-block__price">
							{{ INDRA_printCost() }}
						</div>
					</div>
				</div>
				<app-svg *ngIf="INDRA_printPartnerLogo()" 
					class="ancillary-block__partner-logo" 
					svg="{{INDRA_printPartnerLogo()}}" 
					[alt]="'Provider logo'">
				</app-svg>
			</div>
		</div>
		<div class="ancillary-block__discount" *ngIf=INDRA_hasDiscount() aria-hidden=true>
			{{ INDRA_printDiscount() }}
		</div>
	</article>
</ng-template>
